// frontend/src/components/charts/DeviceDonut.jsx
import React from "react";
import PropTypes from "prop-types";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import ChartCard from "./ChartCard";

//: Palette for the device-split donut (mobile / desktop / tablet / …).
const DEVICE_COLORS = ["#2563eb", "#16a34a", "#f59e0b", "#a855f7", "#ef4444"];

/**
 * DeviceDonut — device-type split as a donut chart.
 *
 * @param {{
 *   data: Array<{ device_type: string, count: number }>,
 *   title?: string,
 *   height?: number
 * }} props
 */
function DeviceDonut({ data, title = "Device split", height = 240 }) {
  return (
    <ChartCard title={title} isEmpty={data.length === 0}>
      <ResponsiveContainer width="100%" height={height}>
        <PieChart>
          <Pie
            data={data}
            dataKey="count"
            nameKey="device_type"
            innerRadius={55}
            outerRadius={90}
            paddingAngle={2}
          >
            {data.map((entry, i) => (
              <Cell
                key={entry.device_type}
                fill={DEVICE_COLORS[i % DEVICE_COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
DeviceDonut.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({ device_type: PropTypes.string, count: PropTypes.number }),
  ).isRequired,
  title: PropTypes.string,
  height: PropTypes.number,
};

export default DeviceDonut;
